module.exports = __webpack_public_path__ + "img/cloud-sleet.cc5380e1.svg";